module.exports = __webpack_public_path__ + "static/media/Madalina Isac.ca8d33f2.png";